/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {User, UserFromJSON, UserToJSON,} from './User';

/**
 *
 * @export
 * @interface UserApiResult
 */
export interface UserApiResult {
    /**
     *
     * @type {boolean}
     * @memberof UserApiResult
     */
    success?: boolean;
    /**
     *
     * @type {User}
     * @memberof UserApiResult
     */
    content?: User;
    /**
     *
     * @type {string}
     * @memberof UserApiResult
     */
    message?: string | null;
}

export function UserApiResultFromJSON(json: any): UserApiResult {
    return UserApiResultFromJSONTyped(json, false);
}

export function UserApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : UserFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function UserApiResultToJSON(value?: UserApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': UserToJSON(value.content),
        'message': value.message,
    };
}

